<template>
  <div class="container">
    <div class="header">
      <div class="logo">
        <img src="../assets/images/logo-small.png" alt="logo"/>
        <span>Your TPR Coin Allocation Platform</span>
      </div>
      <div class="login" @click="logout">logout</div>
    </div>
    <main class="main">
      <router-view/>
    </main>
    
  </div>
</template>

<script>
export default {
  methods: {
    logout() {
      this.$store.dispatch('logout')
          .then(() => {
            this.$router.push('/admin')
          })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #edf1f9;
    padding-right: 10px;
    width: 100%;
    background: #0D1F3C;

    .logo {
      display: flex;
      align-items: center;

    }

    .login {
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      display: flex;
      align-items: center;
      text-align: right;
      letter-spacing: 0.01em;
      text-transform: uppercase;
      color: #edf1f9;
      cursor: pointer;
    }
  }

  .main {
    padding: 24px;
    background: #F5F5F5;
    width: 100%;
    height: 100%;
  }
}
</style>